import { Injectable, signal } from '@angular/core';

const TRANSITION_MS = 1000;

@Injectable({
  providedIn: 'root',
})
export class BrandSwitchTransitionService {
  readonly visible = signal(false);
  readonly brandName = signal('');
  readonly logoKey = signal('');

  private hideTimer?: ReturnType<typeof setTimeout>;

  play(brand: { companyName?: string; companyLogo?: string }): void {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
    }

    this.brandName.set(brand.companyName ?? '');
    this.logoKey.set(brand.companyLogo ?? '');
    this.visible.set(false);

    queueMicrotask(() => {
      this.visible.set(true);
      this.hideTimer = setTimeout(() => this.visible.set(false), TRANSITION_MS);
    });
  }
}
